"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragArea = exports.StyledDragArea = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const timeout_hook_1 = require("../hooks/timeout.hook");
exports.StyledDragArea = styled_components_1.default.div `
  position: relative;
  border-radius: 2px;
  border: 3px dashed ${props => (0, core_1.alpha)(props.theme.palette.primary.main, 0)};
  transition: background-color 300ms cubic-bezier(0.075, 0.82, 0.165, 1),
    border 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
  &.dragging {
    border: 3px dashed ${props => props.theme.palette.primary.main};
    background-color: ${props => (0, core_1.alpha)(props.theme.palette.primary.main, 0.12)};
    .drag-empty-container {
      border: 1px solid ${props => (0, core_1.alpha)(props.theme.palette.divider, 0)};
    }
  }
  .hidden {
    display: none;
  }
  .drag-empty-container {
    &:not(.hidden) {
      display: flex;
    }
    padding: 16px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    border: 1px solid ${props => props.theme.palette.divider};
    transition: border 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
  }
  .drag-text,
  .drag-button {
    margin: 10px 0;
  }
`;
const DragArea = props => {
    const { disabled, hideArea, className, children, dragLabel = 'Drag one or more files to upload', buttonLabel = 'Select Files', onClick, onUpload, dragOver: dragOverProp, setDragOver: setDragOverProp } = props;
    const dragOverState = (0, react_1.useState)(false);
    const [debounceLeave, clearDebouncedLeave] = (0, timeout_hook_1.useTimeout)();
    const dragOver = dragOverProp !== null && dragOverProp !== void 0 ? dragOverProp : dragOverState[0];
    const setDragOver = setDragOverProp !== null && setDragOverProp !== void 0 ? setDragOverProp : dragOverState[1];
    const classes = [];
    className && classes.push(className);
    dragOver && classes.push('dragging');
    const areaClasses = ['drag-empty-container'];
    hideArea && areaClasses.push('hidden');
    return (react_1.default.createElement(exports.StyledDragArea, { className: classes.join(' '), onDragOver: event => {
            clearDebouncedLeave();
            if (!disabled) {
                event.preventDefault();
                setDragOver(true);
            }
        }, onDragLeave: () => {
            // delay set to false to avoid the area from flickering
            debounceLeave(() => {
                !disabled && setDragOver(false);
            }, 50);
        }, onDrop: event => {
            clearDebouncedLeave();
            if (!disabled) {
                event.preventDefault();
                setDragOver(false);
                onUpload === null || onUpload === void 0 ? void 0 : onUpload(event.dataTransfer.files);
            }
        } },
        react_1.default.createElement("div", { className: areaClasses.join(' ') },
            react_1.default.createElement(core_1.Typography, { variant: 'subtitle2', className: 'drag-text' }, dragLabel),
            react_1.default.createElement(core_1.Typography, { variant: 'subtitle2', className: 'or-text' }, "-- or --"),
            react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'outlined', className: 'drag-button', disabled: disabled, onClick: onClick }, buttonLabel)),
        children));
};
exports.DragArea = DragArea;
exports.default = exports.DragArea;
//# sourceMappingURL=FileDragArea.js.map